<template>
  <div
    id="resource_wms_style-container"
    :class="{
      fullscreen: isFullScreen
    }"
  >
    <b-overlay
      no-wrap
      :show="loading"
      :variant="'white'"
      :opacity="0.7"
      :blur="'2px'"
      rounded="sm"
    />
    <button
      id="open_style_editor_button"
      class="btn btn-primary"
      type="button"
      @click.stop="openMapsWCStyleEditor"
    >
      {{ $t('resource.accordion.style.openStyleButton') }}
    </button>
    <ogs-maps
      id="webcomponent"
      vue3d="false"
      style="width:100%;height:600px;display: block;"
    />
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import {
  DEFAULT_MAPS_CONTEXT,
  MAPS_GEOMETRY_TYPES_MAPPING
} from '@/common/data/constants.js';

export default {
  name: 'ResourceWMSStyle',

  data() {
    return {
      loading: false,
      isFullScreen: false
    };
  },

  computed: {
    ...mapState('resources', [
      'mainResourceGeoData',
    ]),
    ...mapState('geospatial', [
      'currentGeographicLayerStyles',
      'currentGeographicLayerStyleConfig'
    ])
  },

  watch: {
    mainResourceGeoData: {
      deep: true,
      handler(newValue, oldValue) {
        if (
          newValue &&
          newValue !== oldValue &&
          newValue.id
        ) {
          this.initMapsWC();
        }
      }
    }
  },

  async created () {
    if (
      this.mainResourceGeoData &&
      this.mainResourceGeoData.id
    ) {
      this.initMapsWC();
    }
    this.loading = false;
  },

  methods: {
    ...mapActions('geospatial', [
      'GET_CURRENT_GEOGRAPHIC_LAYER_STYLES',
      'GET_CURRENT_GEOGRAPHIC_LAYER_STYLE',
      'SAVE_CURRENT_GEOGRAPHIC_LAYER_STYLE',
    ]),
    async initMapsWC() {
      try {
        // Fetch previously saved styles
        this.loading = true;
        await this.GET_CURRENT_GEOGRAPHIC_LAYER_STYLES(this.mainResourceGeoData.id);
        if (this.currentGeographicLayerStyles && this.currentGeographicLayerStyles.length) {
          await this.GET_CURRENT_GEOGRAPHIC_LAYER_STYLE({
            geographiclayerId: this.mainResourceGeoData.id,
            styleId: this.currentGeographicLayerStyles[0].id
          });
        }

        const webcomponent = document.getElementById('webcomponent');
        const style = document.createElement( 'style' );
        style.innerHTML = '.modal-dialog-scrollable { margin-top: 5rem; max-height: calc(100% - 7rem); }';
        webcomponent.shadowRoot.appendChild( style );
        const mapComponent = webcomponent.vueComponent;

        // Load config
        mapComponent.loadConfig({
          // base_api_url: 'http://localhost/semsamar_recette/backend-maps/',
          // maps_api_url: '/ogsrecette/fr/maps/maps',
          // documentation_url: '',
          static_base_url:this.$config.wms.staticBaseUrl,
          // cors_proxy_url: '/service/proxy/?url=',
        });

        // Load default map context
        mapComponent.loadMap(DEFAULT_MAPS_CONTEXT);

        // 3 - add ressource layer to map
        if (this.currentGeographicLayerStyleConfig) {
          this.maplayer = mapComponent.addLayerToMap(this.currentGeographicLayerStyleConfig);
        } else {
          this.maplayer = mapComponent.addLayerToMap({
            layername: this.mainResourceGeoData.layerName,//'magosm:france_pnr_polygon',
            title: this.mainResourceGeoData.display_name,//'Parcs Naturels Régionaux - France métropolitaine',
            type: 'WMS',
            visible: true,
            useSldBody: true,
            targetNamespace: 'magosm',
            targetPrefix: 'magosm',
            boundingBoxEPSG4326: this.mainResourceGeoData.latlon_bounding_box,//[-6.288, 37.436, 14.373, 53.092],
            url: `${process.env.VUE_APP_DOMAIN}/geoserver/ows/?service=wms&version=1.3.0&request=GetCapabilities`,
            geometryType: MAPS_GEOMETRY_TYPES_MAPPING[this.mainResourceGeoData.gis_data_type.id]
          });
        }

        // mapComponent.contextService.setCurrentAction('infoLayer', this.maplayer);
        // mapComponent.getEventBus().$emit('OPEN_LAYER_CONFIG_TAB', 3);

        // 4 - listen for update on layer        
        mapComponent.getEventBus().$on('LAYER_UPDATED', (layer) => {
          const config = layer.toJson();
          this.SAVE_CURRENT_GEOGRAPHIC_LAYER_STYLE({
            geographiclayerId: this.mainResourceGeoData.id,
            styleId:
              this.currentGeographicLayerStyles &&
              this.currentGeographicLayerStyles.length &&
              this.currentGeographicLayerStyles[0].id ?
                this.currentGeographicLayerStyles[0].id :
                null,
            data: {
              codename: this.mainResourceGeoData.codename,
              display_name: config.title,
              description: this.mainResourceGeoData.description
            },
            config: config,
            sld: layer.styletoSld()
          });
        });
        this.loading = false;
      } catch (err) {
        console.error(err);
        this.loading = false;
      }
    },

    setActiveStyle() {
      setTimeout(() => {
        const mapComponent = document.getElementById('webcomponent').vueComponent;
        mapComponent.contextService.setCurrentAction('infoLayer', this.maplayer);
        setTimeout(() => {
          mapComponent.mapService.zoomToLayer(this.maplayer);
          mapComponent.getEventBus().$emit('OPEN_LAYER_CONFIG_TAB', 3);
        },200);
      }, 600);
    },

    openMapsWCStyleEditor() {
      const mapComponent = document.getElementById('webcomponent').vueComponent;
      mapComponent.contextService.setCurrentAction('infoLayer', this.maplayer);
      setTimeout(() => {
        mapComponent.getEventBus().$emit('OPEN_LAYER_CONFIG_TAB', 3);
      }, 200);
    }
  }
};
</script>

<style lang="less" scoped>
#resource_wms_style-container {
  position: relative;
  #open_style_editor_button {
    position: absolute;
    top: 1rem;
    right: 1rem;
    z-index: 2;
  }
  i.bi {
    position: absolute;
    top: 0.5rem;
    right: 0.5rem;
    font-size: 1.5rem;
    text-shadow: 2px 2px 3px #9d9d9d;
    cursor: pointer;
    z-index: 2;
  }
  i.bi:hover {
    transform: scale(1.1);
  }
}
#resource_wms_style-container.fullscreen {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
</style>